import React, { useEffect, useRef } from "react";

import {
  Chart as ChartJS,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Filler,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
import {
  BarWithErrorBar,
  BarWithErrorBarsController,
} from "chartjs-chart-error-bars";

ChartJS.register(
  BarWithErrorBarsController,
  BarWithErrorBar,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Filler,
  Legend,
  Title,
  Tooltip,
);

export function Chart({
  className = "",
  height = 300,
  config,
  plugins = [],
  onChartUpdated = (_) => null,
}) {
  const container = useRef(null);
  const chart = useRef(null);

  useEffect(() => {
    config.type ??= "line";
    config.options ??= {};
    config.options.maintainAspectRatio ??= false;
    config.options.tooltips ??= {};
    config.options.tooltips.intersect ??= false;
    config.options.tooltips.mode ??= "index";
    config.plugins = plugins;

    if (config?.disableAnimations === true) {
      config.options.animation = false;
    }

    chart.current = new ChartJS(container.current, config);

    return () => chart.current.destroy();
    // eslint-disable-next-line
  }, []);

  // console.log(data)

  useEffect(() => {
    chart.current.data = config.data;
    chart.current.options = config.options;
    chart.current.update();

    onChartUpdated(chart.current);
  }, [config]);

  return (
    <div className={"_relative " + className} style={{ height }}>
      <canvas
        // style={{ width: 400, height: 400 }}
        // className="absolute top-0 bottom-0 left-0 right-0"
        ref={container}
      />
    </div>
  );
}
